import { graphqlApi } from './graphQL'
import { GqlFetchDocsLinkQuery } from './graphqlTypes'

export async function fetchDocsUrl(): Promise<GqlFetchDocsLinkQuery> {
  const api = await graphqlApi()
  return api.FetchDocsLink()
}
